import './Stack.css';

const GROUPS = [
  {
    k: 'Languages',
    core: ['TypeScript', 'JavaScript', 'Python', 'SQL'],
    rest: ['Java', 'C / C++', 'C#', 'PHP', 'Bash', 'PowerShell', 'Solidity'],
  },
  {
    k: 'Frontend',
    core: ['React', 'Next.js', 'Tailwind CSS'],
    rest: ['Three.js', 'React Three Fiber', 'TanStack Query', 'Zustand', 'Recharts', 'PWA', 'HTML5', 'CSS3'],
  },
  {
    k: 'Backend & APIs',
    core: ['Node.js', 'Express', 'REST'],
    rest: ['FastAPI', 'Django', 'GraphQL', 'WebSockets'],
  },
  {
    k: 'Applied ML',
    core: [],
    rest: ['TensorFlow / Keras', 'Scikit-learn', 'Optuna', 'Anthropic API', 'OCR pipelines'],
  },
  {
    k: 'Cloud & DevOps',
    core: ['AWS', 'Google Cloud', 'Docker', 'CI/CD'],
    rest: ['Kubernetes', 'Nginx', 'Linux (RHEL)', 'Git', 'Server hardening'],
  },
  {
    k: 'Data & Auth',
    core: ['PostgreSQL', 'MongoDB', 'Redis'],
    rest: ['MariaDB', 'JWT', 'OAuth', 'Stripe'],
  },
  {
    k: 'Enterprise & tooling',
    core: [],
    rest: ['SAP S/4HANA', 'UiPath RPA', 'WordPress', 'LaTeX', 'Microsoft Office'],
  },
];

export default function Stack() {
  return (
    <section id="stack" className="band sk">
      <div className="shell">

        <div className="sec-head" data-rv="up">
          <span className="sec-tag"><b>06</b> — Stack</span>
          <h2 className="display-lg">
            <span className="mask-line"><span>What I actually</span></span>
            <span className="mask-line" style={{ '--ml-d': '110ms' }}><span>reach for.</span></span>
          </h2>
          <p className="lede">
            Filled markers are daily drivers I would defend in a design review. The rest is
            working knowledge — enough to ship with, not enough to oversell.
          </p>
        </div>

        <div className="sk-legend" data-rv="fade">
          <span><i className="sk-dot sk-dot--core" />Daily driver</span>
          <span><i className="sk-dot" />Working knowledge</span>
        </div>

        <div className="sk-rows">
          {GROUPS.map((g, i) => (
            <div
              className="sk-row"
              key={g.k}
              data-rv="up"
              style={{ '--rv-d': `${i * 70}ms` }}
            >
              <div className="sk-row-k">
                <span className="sk-row-idx">{String(i + 1).padStart(2, '0')}</span>
                <span className="sk-row-name">{g.k}</span>
              </div>
              <div className="sk-row-items">
                {g.core.map((s) => (
                  <span className="sk-item sk-item--core" key={s}>
                    <i className="sk-dot sk-dot--core" />{s}
                  </span>
                ))}
                {g.rest.map((s) => (
                  <span className="sk-item" key={s}>
                    <i className="sk-dot" />{s}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
